import React from 'react'
import styled, { css } from 'styled-components'

import { Heading2, Heading4 } from '../../styles/Text'

import caretDown from '../../images/caret-down.svg'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const Subheading = styled(Heading4)`
  margin-top: 32px;
  margin-bottom: 32px;
`

const ErrorMessage = styled.p`
  margin-top: 8px;
  color: #f11b1b;
`

const RowItem = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  ${(p) =>
    p.multiple &&
    css`
      :nth-child(2) {
        margin-top: 32px;
      }
    `}
  @media (min-width: ${(p) => p.theme.breakpointMd}) {
    width: 100%;
  }
  ${(p) =>
    p.select &&
    css`
      ::before {
        content: '';
        background-image: url(${caretDown});
        background-size: cover;
        position: absolute;
        right: 20px;
        top: 18px;
        width: 24px;
        height: 24px;
        pointer-events: none;
        z-index: 1;
      }
    `}
`

const Select = styled.select`
  width: 100%;
  position: relative;
  padding: 13px 16px;
  border: 3px solid ${(p) => p.theme.textColor};
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 172%;
  outline: none;
  background-color: white;
  appearance: button;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  color: ${(p) => p.theme.textColor};
  ::placeholder {
    color: #7f7fa3;
  }
  :focus-visible {
    border: 3px solid #5f30e2;
  }
  ${(p) => p.selected && 'border: 3px solid #5F30E2;'}
  ${(p) => p.error && 'border: 3px solid #F11B1B;'}
`

const Dropdown = () => {
  return (
    <>
      <Heading>Dropdown</Heading>
      <Subheading>Default</Subheading>
      <RowItem select multiple>
        <Select id="default" name="default">
          <option value="Select">Select</option>
          <option value="2-10">2-10</option>
          <option value="11-50">11-50</option>
          <option value="51-200">51-200</option>
          <option value="200+">200+</option>
        </Select>
      </RowItem>
      <Subheading>Selected</Subheading>
      <RowItem select multiple>
        <Select id="selected" name="selected" selected>
          <option value="Select">Select</option>
          <option value="2-10">2-10</option>
          <option value="11-50">11-50</option>
          <option value="51-200">51-200</option>
          <option value="200+">200+</option>
        </Select>
      </RowItem>
      <Subheading>Error</Subheading>
      <RowItem select multiple>
        <Select id="error" name="error" error>
          <option value="Select">Select</option>
          <option value="2-10">2-10</option>
          <option value="11-50">11-50</option>
          <option value="51-200">51-200</option>
          <option value="200+">200+</option>
        </Select>
      </RowItem>
      <ErrorMessage>Please enter your “heading here”</ErrorMessage>
    </>
  )
}

export default Dropdown
